<template>
  <div v-if="jwtAccessValid() && userProfile.checked && isWholesaler || isAdmin || isDriver">

    <shipments-card v-if="isMobile"/>
    <shipments-table v-else/>

  </div>
</template>

<script>
/* eslint-disable no-console */
import { ref, computed, onMounted } from "vue"
import { useStore } from 'vuex';
import { useRouter } from 'vue-router'
import useCommonMixin from '@/components/commonMixin.js'
import ShipmentsTable from "./ShipmentsTable.vue";
import ShipmentsCard from "./ShipmentsCard.vue";

export default {
  name: 'Shipments',
  components: { ShipmentsTable, ShipmentsCard
  },

  setup(props) {
    useCommonMixin()
    const { jwtAccessValid, asyncForEach, isReciever, isDriver, userProfile, isAdmin, isMobile, isWholesaler } = useCommonMixin()
    const store = useStore()
    const router = useRouter()
    const docs = ref([])
    const profiles = ref([{}])

    const init = async () => {
      let response = await store.dispatch('FETCHshipment')
      docs.value = response.status ? response.data : []
    }

    const getProfile = (profileId) => {
      let profileIndex = profiles.value.findIndex(item => item._id == profileId)
      return (profileIndex >= 0) ? profiles.value[profileIndex] : { company: '', fullname: '' }
    }

    const docSum = (doc) => {
      return Object.values(doc.tableUnit).reduce((a, b) => a + b.weight * b.price, 0)
    }

    onMounted(init)

    return {
      jwtAccessValid,
      isReciever,
      docs,
      getProfile,
      profiles,
      docSum,
      router,
      userProfile,
      isAdmin,
      isMobile,
      isDriver,
      isWholesaler,
    }
  }


}

</script>

<style>
</style>

